import React from 'react';

import InputBase from 'apps/auth/components/form-multi/InputBase';
import { notValidateUpdateValue, validationAndUpdateValue } from 'apps/auth/components/form-multi/utils';
import { DEFAULT_DATE_REGEX } from 'apps/auth/constants/utilsMasks';
import { inputPropType } from 'apps/auth/helpers/customPropTypes';
import update from 'apps/auth/helpers/Immutability';
import Inputmask from 'inputmask';

class InputDateHOC extends React.Component {
    constructor(props) {
        super(props);
        this.inputRef = React.createRef();
        this.handlerChange = this.handlerChange.bind(this);
        this.handlerBlur = this.handlerBlur.bind(this);
    }

    componentDidMount() {
        Inputmask({
            placeholder: this.props.usaDateFormat ? 'mm/dd/yyyy' : 'dd.mm.yyyy',
            showMaskOnHover: false,
            showMaskOnFocus: true,
        }).mask(this.inputRef.current);
    }

    handlerChange(e) {
        e.preventDefault();
        const field = this.props.field;
        if (!field.isReadOnly) {
            const value = e.target.value ? e.target.value.replace(/[a-zA-Z]/g, '') : '';
            notValidateUpdateValue(this.props.formName, value, field, this.props.changeFormField).then(() => {
                if (this.props.onChangeHandler) {
                    this.props.onChangeHandler(value, field.name);
                }
            });
        }
    }

    handlerBlur(e) {
        e.preventDefault();
        let field = this.props.field;
        if (!field.isReadOnly) {
            const value = e.target.value ? e.target.value.replace(/[a-zA-Z]/g, '') : '';
            if (!field.checkRegexp && !this.props.usaDateFormat) {
                field = update(field, {
                    checkRegexp: { $set: DEFAULT_DATE_REGEX },
                });
            }
            validationAndUpdateValue(this.props.formName, value, field, this.props.changeFormField).then(() => {
                if (this.props.onBlurHandler) {
                    this.props.onBlurHandler(value, field.name, field.checkRegexp, field.mandatory, field);
                }
            });
        }
        if (this.props.inputBaseHandlerBlur) {
            this.props.inputBaseHandlerBlur(e);
        }
    }

    render() {
        const field = this.props.field;
        const regex = this.props.usaDateFormat ? field.checkRegexp : field.checkRegexp ? field.checkRegexp : DEFAULT_DATE_REGEX;
        return (
            <input
                type="tel"
                maxLength={this.props.setMaxLength && field.maxLength ? field.maxLength : ''}
                autoComplete="off"
                id="inputMask"
                ref={this.inputRef}
                data-inputmask-regex={regex}
                value={field.value || ''}
                readOnly={field.isReadOnly}
                onFocus={field.isReadOnly ? null : this.props.onFocus}
                onChange={this.handlerChange}
                onBlur={this.handlerBlur}
            />
        );
    }
}

InputDateHOC.defaultProps = {
    usaDateFormat: false,
};

const InputDate = InputBase(InputDateHOC);

InputDate.propTypes = inputPropType(['date']);

export default InputDate;
